<template>
  <div>
    <div class="banner innerpageBanner">
      <div class="container">
        <div class="caption">
          <div>
            <h1>Inside Burgundy</h1>
            <p>The book and eBooks</p>
            <p>
              <a class="btn" href="index.html#">阅读更多</a>
            </p>
          </div>
        </div>
      </div>

      <img
        src="https://www.insideburgundy.com/wp-content/uploads/2018/09/banner2-1600x600.jpg"
        alt
        class="cover-image"
      >
    </div>

    <section class="innerPage">
      <div class="container">
        <div class="breadcrumbWrap">
          <div class="breadcrumb">
            <!-- Breadcrumb NavXT 6.2.0 -->
            <span property="itemListElement" typeof="ListItem">
              <a
                property="item"
                typeof="WebPage"
                title="Go to Jasper Morris Inside Burgundy."
                href="index.html#/insideburgundy"
                class="home"
              >
                <span property="name">Home</span>
              </a>
              <meta property="position" content="1">
            </span> /
            <span property="itemListElement" typeof="ListItem">
              <span property="name">Inside Burgundy – The Book</span>
              <meta property="position" content="2">
            </span>
            <div data-object_id="15" class="cbxwpbkmarkwrap cbxwpbkmarkwrap-page">
              <a
                data-loggedin="0"
                data-type="page"
                data-object_id="15"
                class="cbxwpbkmarktrig cbxwpbkmarktrig-button-addto"
                title="Bookmark This"
                href="#"
              >
                <span class="cbxwpbkmarktrig-label">Bookmark</span>
              </a>
              <div
                data-type="page"
                data-object_id="15"
                class="cbxwpbkmarkguestwrap"
                id="cbxwpbkmarkguestwrap-15"
              >
                <div class="cbxwpbkmarkguest-message">
                  <a href="#" class="cbxwpbkmarkguesttrig_close"></a>
                  <a class="cbxwpbkmarkguest-text" href="index.html#/Login">Please login to bookmark</a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Search -->
       <searchBox  />

        <div class="leftCol">
          <div class="post" id="post-15">
            <div class="entry">
              <h2>The book &amp; eBooks</h2>
              <p>
                <em>Inside Burgundy</em> has been a critical and sales success ever since first publication in 2010. It is at once personal and encyclopaedic, offering detailed knowledge gained over decades allied to insights into the places – and above all the people – that make Burgundy so special. In the main part of the book, Jasper Morris describes more than 1,000 vineyards and 150 wine villages, and profiles and appraises some 450 producers. Added to this are chapters on the background to Burgundy – geography, winemaking, grapes – and on vintages. Thirty-six unique, highly-detailed maps offer insights into the complex network of vineyards and appellations.
              </p>
              <p>The hardback book (654 pages and 2 kilos) is complemented by eBooks, designed to be enjoyed on iPad, iPhone and Mac screens. Electronic capability adds video clips – stand with Jasper in the vineyards – zoomable, interactive maps and beautiful colour photographs to the award-winning text.</p>
              <h4>Contents</h4>
              <p>
                Foreword by Steven Spurrier
                <strong>
                  <br>
                </strong>
                <span class="s1">
                  List of Maps
                  <br>
                </span>
                <span class="s1">
                  Acknowledgements
                  <br>
                </span>
                <span class="s1">
                  Introduction
                  <br>
                </span>
                <span class="s1">
                  How to use this book
                  <br>
                </span>
                <span class="s1">Glossary</span>
              </p>
              <p>
                <strong>&nbsp;</strong>
              </p>
              <h6>Background to Burgundy</h6>
              <p>
                The historical background
                <br>Burgundy wine trade
                <br>The geography: terroir, geology &amp; soil
                <br>The weather: wind, rain, hail, frost &amp; sun
                <br>White grapes
                <br>Red grapes
                <br>Viticulture
                <br>The harvest
                <br>In search of a style
                <br>Making white wine
                <br>Making red wine
              </p>
              <p>&nbsp;</p>
              <h6>Vineyards &amp; vignerons</h6>
              <p>The appellations &amp; classifications</p>
              <ul class="hardbackListing">
                <li>
                  <h6>Côte de Nuits</h6>
                  <p>
                    Côte de Nuits–Villages
                    <br>Marsannay
                    <br>Fixin
                    <br>Gevrey-Chambertin
                    <br>Morey-St-Denis
                    <br>Chambolle-Musigny
                    <br>Vougeot
                    <br>Vosne-Romanée &amp; Flagey-Echézeaux
                    <br>Nuits-St-Georges
                  </p>
                </li>
                <li>
                  <h6>Côte de Beaune</h6>
                  <p>
                    The Hill of Corton
                    <br>Beaune
                    <br>Savigny- &amp; Chorey-lès-Beaune
                    <br>Pommard
                    <br>Volnay
                    <br>Auxey-Duresses, Monthélie, St-Romain
                    <br>Meursault &amp; Blagny
                    <br>The Montrachets
                    <br>Puligny-Montrachet
                    <br>Chassagne-Montrachet
                    <br>St-Aubin
                    <br>Santenay
                    <br>Maranges
                  </p>
                </li>
                <li>
                  <h6>Greater Burgundy</h6>
                  <p>
                    Bourgogne
                    <br>Crémant de Bourgogne
                    <br>The Hautes-Côtes
                    <br>Chablis
                    <br>The Auxerrois
                    <br>Côte Chalonnais
                    <br>The Mâconnais
                    <br>Pouilly-Fuissé
                  </p>
                </li>
                <li>
                  <a name="book"></a>
                  <br>
                  <h6>Reference</h6>
                  <p>
                    Appreciating Burgundy
                    <br>Vintages
                    <br>Bibliography
                    <br>Index
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gridBoxes three small">
          <h2>Buy the book...</h2>
          <ul>
            <li>
              <div class="content">
                <div class="img">
                  <img
                    src="https://www.insideburgundy.com/wp-content/uploads/2018/07/news2.jpg"
                    alt="The eBooks"
                    class="cover-image"
                  >
                </div>
                <div class="discription">
                  <h6>
                    <a href target>The eBooks</a>
                  </h6>
                  <p>Berry Bros. &amp; Rudd Press is in the forefront of wine book publishing in a range of formats. Beginning with the iPad, we have created versions of the book readable on iPhones and on Mac computers.</p>
                </div>
                <a href="index.html#" target class="readmore">WHERE TO BUY</a>
              </div>
            </li>

            <li>
              <div class="content">
                <div class="img">
                  <img
                    src="https://www.insideburgundy.com/wp-content/uploads/2018/07/aboout.jpg"
                    alt="The hardback"
                    class="cover-image"
                  >
                </div>
                <div class="discription">
                  <h6>
                    <a href="index.html#" target>The hardback</a>
                  </h6>
                  <p>To buy the traditional printed book follow the links, depending upon your location. For the UK and Europe, the best route is via Berry Bros &amp; Rudd (free of charge to UK destinations).</p>
                </div>
                <a href="index.html#" target class="readmore">WHERE TO BUY</a>
              </div>
            </li>

            <li>
              <div class="content">
                <div class="img">
                  <img
                    src="https://www.insideburgundy.com/wp-content/uploads/2018/07/news3.jpg"
                    alt="The book in French &amp; Japanese"
                    class="cover-image"
                  >
                </div>
                <div class="discription">
                  <h6>
                    <a href="index.html#" target>The book in French &amp; Japanese</a>
                  </h6>
                  <p>
                    Our friends Berry Bros &amp; Rudd Press is proud to offer
                    <em>Inside Burgundy</em> in Japanese and French.
                  </p>
                </div>
                <a href="index.html#" target class="readmore">WHERE TO BUY</a>
              </div>
            </li>
          </ul>
          <!-- Top 3 blocks -->
        </div>
        <div class="reviewWrap">
          <h4>Reviews</h4>
          <div class="reviews">
            <div class="qoutes">
              <div class="qouteContent">
                <p>
                  <i>As I read I feel that Jasper is acting as my trusted guide through the complexities of this wonderful region. I think he really understands Burgundy – he ‘gets’ it.</i>
                </p>
              </div>
              <p class="author">- Jamie Good, The Wine Anorak</p>
            </div>
            <div class="qoutes">
              <div class="qouteContent">
                <p>
                  <i>This puts all the electronic ‘e’s into Beaune Heaven. The maps are coloured, crisp and detailed, with a ‘tap to zoom’ feature that had me peering at the contour lines of Chassagne-Montrachet for a mesmerised time. I’d practically walked that vineyard by the time I left the page.</i>
                </p>
                <p>
                  <em>Visually, it’s a delight. The font and clarity and spacing of the layout is so crystal-clear… What gives the e-book a jewelled edge is the addition of the luminously beautiful photographs; Burgundy seen through the lens of an artist, glowing with colour and so vivid it looks close enough to touch.</em>
                </p>
              </div>
              <p class="author">- Tamlyn Currin, JancisRobinson.com</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Subsribe Form section Bottom -->
    <!-- Subsribe Form section Bottom -->
    <iframe
      name="stripeXDM_default499182_provider"
      id="stripeXDM_default499182_provider"
      aria-hidden="true"
      src="https://js.stripe.com/v2/channel.html?stripe_xdm_e=https%3A%2F%2Fwww.insideburgundy.com&amp;stripe_xdm_c=default499182&amp;stripe_xdm_p=1#__stripe_transport__"
      frameborder="0"
      style="position: absolute; top: -2000px; left: 0px;"
    ></iframe>
    <div class="remodal-overlay remodal-is-closed" style="display: none;"></div>
    <div class="remodal-wrapper remodal-is-closed" style="display: none;">
      <div
        data-remodal-id="loginForm"
        class="remodal loginForm remodal-is-initialized remodal-is-closed"
        data-remodal-options="hashTracking: false"
        tabindex="-1"
      >
        <a href="javascript:void(0);" data-remodal-action="close" class="remodalClose">Close</a>
        <ul class="tabs">
          <li class="tab-link current loginLink" data-tab="tab-1">Log In</li>
          <li class="tab-link registerLink" data-tab="tab-2">Register</li>
        </ul>
        <div class="remodal_content">
          <div id="tab-1" class="tab-content current login">
            <h5>
              Log in to Inside
              <span class="burgundy">Burgundy</span>
            </h5>
            <p>Register with Inside Burgundy and select a membership plan that works for you</p>
            <a href="https://www.insideburgundy.com/login/" class="btn white">Click here to Login</a>
          </div>
          <div id="tab-2" class="tab-content register">
            <h5>Register with Inside Burgundy</h5>
            <p>Register with Inside Burgundy and select a membership plan that works for you</p>
            <a
              href="https://www.insideburgundy.com/register/"
              class="btn white"
            >Click here to register</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import searchBox from '../template/search'

export default {
  components:{
    searchBox
  },
  methods: {
    hreftwo() {
      this.$router.push({ path: "./insideburgundy" });
    },

    name: "HelloWorld",
    changeActive($event) {
      $event.currentTarget.style = "border-bottom: 4px solid #990033;";
    },
    removeActive($event) {
      $event.currentTarget.style = "";
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Latest.vue